import React, { useState } from "react";
import { Input } from "antd";
import { useNavigate } from "react-router-dom";

import { GET_ORGANIZERS_CURSOR } from "graphql/query/organizer-gql";

import Organizer from "components/organizer";
import Icons from "components/icons";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import Localize, { localizeByKey } from "components/service/localize";
import { PermissionButton } from "components/permissions";
import { usePageNavbarPermissions } from "components/permissions/hooks/use-page-navbar-permissions";
import OrganizerConst from "components/organizer/organizer-const";
import ExhibitionConst from "components/exhibition/exhibition-const";

import "./organizer.scss";

const { Search } = Input;

const basePath = Organizer.Const.basePath;
const tableHelper = Organizer.Helpers.TableMain;

const OrganizersPage = () => {
  useActiveMenuItem(["organizers"], ["organizers"]);

  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_Organizers"),
      path: `${basePath}`,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  const pageNavbar = [
    {
      label: localizeByKey("NAVBAR_PAGES.Label_Organizers"),
      path: "organizers",
      permission: OrganizerConst.permissions.VIEW,
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_ExhibitionTypes"),
      path: "exhibition-types",
      permission: ExhibitionConst.permissions.VIEW,
    },
  ];

  const { filteredNavbarItems } = usePageNavbarPermissions({ navbarItems: pageNavbar });

  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  return (
    <PageWrapDefault
      className="page-organizers"
      dataExist={true}
      title={<Localize>PAGES.Title_Organizers</Localize>}
      pageNavbar={filteredNavbarItems}
      staticPath=""
    >
      <Tables.Cursor
        model="organizersCursor"
        query={GET_ORGANIZERS_CURSOR}
        varSet={{ perPage: 50 }}
        routeUrl={`${basePath}`}
        searchText={searchText}
        tableHelper={tableHelper}
      >
        <div className="table-action-bar">
          <div className="col">
            <Search
              className="filter-search"
              prefix={<Icons.Search />}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          <div className="col">
            <PermissionButton
              permission={Organizer.Const.permissions.UPDATE}
              type="primary"
              icon={<Icons.Plus />}
              onClick={() => navigate(`${basePath}/create`)}
              disabledFallback={true}
            >
              <span className="ellipsis">
                <Localize>GLOBAL.Button_Text_CreateNew</Localize>
              </span>
            </PermissionButton>
          </div>
        </div>
      </Tables.Cursor>
    </PageWrapDefault>
  );
};

export default OrganizersPage;
